import $ from 'jquery';
import 'bootstrap-pincode-input';

export function initPincode(elem = document) {
    $(elem).find("[data-provider='pincode']").each(function () {
        let options = {
            inputs: $(this).attr('maxlength'),
            inputtype: 'alphabet',
            inputmode: 'text',
            hidedigits: false,
        };
        if ($(this).attr("data-pincode-inputtype")) {
            options.inputtype = $(this).attr("data-pincode-inputtype").value.toString();
        }
        if ($(this).attr("data-pincode-inputmode")) {
            options.inputtype = $(this).attr("data-pincode-inputmode").value.toString();
        }
        $(this).pincodeInput(options);
    });
}
